import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'dettagli-licenza',
    initialState: {
        licenza: {},
        statusAction: 'READY',
    },
    actions: ['GET_DETTAGLI_LICENZA', 'RESET_DETTAGLI_LICENZA_STORE'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {

            case types.GET_DETTAGLI_LICENZA_SUCCESS:
                return {
                    ...state,
                    licenza: action.payload.licenza
                };

            case types.RESET_DETTAGLI_LICENZA_STORE:
                return {
                    ...state,
                    licenza: {},
                    status: 'READY',
                };

            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        //getLicenseDetails
        getLicenseDetailsRequest: (pk) => ({
            type: types.GET_DETTAGLI_LICENZA_REQUEST,
            payload: { pk },
        }),
        getLicenseDetailsSuccess: ({ licenza }) => ({
            type: types.GET_DETTAGLI_LICENZA_SUCCESS,
            payload: { licenza },
        }),
        getLicenseDetailsFailed: error => ({ type: types.GET_DETTAGLI_LICENZA_FAILED, error: true, payload: { error } }),

        resetLicenseDetails: () => ({
            type: types.RESET_DETTAGLI_LICENZA_STORE,
        }),
    }),
});
